// extracted by mini-css-extract-plugin
module.exports =  {"statCard":"statCard__ep45S","statCardTitle":"statCardTitle__6rRIQ","statCardItem":"statCardItem__f94Tl"};